import { useEffect, useRef } from 'react';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import timeOffAPI from 'state/TimeOff/timeOffApi';

const useCapacityApiFlags = () => {
  const ldClient = useLDClient();
  const { timeOff20 = false } = useFlags<{
    timeOff20?: boolean;
  }>();
  const changeListenerRef = useRef<(() => void) | null>(null);
  const isMountedRef = useRef<boolean>(true);

  useEffect(() => {
    if (!ldClient) {
      return;
    }

    isMountedRef.current = true;

    const updateApiFlags = (timeOff20Flag: boolean) => {
      if (!isMountedRef.current) {
        return;
      }

      const shouldSetHeader = timeOff20Flag;
      timeOffAPI.updateCognotaResourceServiceHeader(shouldSetHeader);
    };

    updateApiFlags(timeOff20);

    const handleFlagChange = () => {
      if (!ldClient || !isMountedRef.current) {
        return;
      }

      const currentTimeOff20Flag = ldClient.variation(
        'time-off-20',
        false
      ) as boolean;

      updateApiFlags(currentTimeOff20Flag);
    };

    ldClient.on('change', handleFlagChange);
    changeListenerRef.current = handleFlagChange;

    return () => {
      isMountedRef.current = false;
      if (ldClient && changeListenerRef.current) {
        ldClient.off('change', changeListenerRef.current);
        changeListenerRef.current = null;
      }
    };
  }, [ldClient, timeOff20]);
};

export default useCapacityApiFlags;
